import { DEFAULT_STATUS_KEY, StatusInfo } from 'src/core/StatusInfo';

export const ApplicationStatusInfoMap: Record<string, StatusInfo> = {
    ON_KYC: {
        color: 'var(--kyc-color)',
        borderColor: 'var(--kyc-border-color)',
        title: 'On KYC Verification',
        backgroundColor: 'var(--kyc-background)',
    },
    VERIFICATION: {
        color: 'var(--verification-color)',
        borderColor: 'var(--verification-border-color)',
        title: 'Verification',
        backgroundColor: 'var(--verification-background)',
    },
    UPDATE_REQUESTED: {
        color: 'var(--update-requested-color)',
        borderColor: 'var(--update-requested-border-color)',
        title: 'Update requested',
        backgroundColor: 'var(--update-requested-background)',
    },
    UNDERWRITING: {
        color: 'var(--underwriting-color)',
        borderColor: 'var(--underwriting-border-color)',
        title: 'Underwriting',
        backgroundColor: 'var(--underwriting-background)',
    },
    DECLINED: {
        color: 'var(--declined-color)',
        borderColor: 'var(--declined-border-color)',
        title: 'Declined',
        backgroundColor: 'var(--declined-background)',
    },
    CANCELED: {
        color: 'var(--canceled-color)',
        borderColor: 'var(--canceled-border-color)',
        title: 'Canceled',
        backgroundColor: 'var(--canceled-background)',
    },
    APPROVED: {
        color: 'var(--approved-color)',
        borderColor: 'var(--approved-border-color)',
        title: 'Approved',
        backgroundColor: 'var(--approved-background)',
    },
    DISBURSED: {
        color: 'var(--disbursed-color)',
        borderColor: 'var(--disbursed-border-color)',
        title: 'Disbursed',
        backgroundColor: 'var(--disbursed-background)',
    },
    ADVANCE_CONSENT_EXPIRED: {
        color: 'var(--advanced-expired-color)',
        borderColor: 'var(--advanced-expired-border-color)',
        title: 'Advanced consent expired',
        backgroundColor: 'var(--advanced-expired-background)',
    },
    ADVANCE_CONSENT_CONFIRMATION: {
        color: 'var(--advanced-consent-color)',
        borderColor: 'var(--advanced-consent-border-color)',
        title: 'Advance consent confirmation',
        backgroundColor: 'var(--advanced-consent-background)',
    },
    AWAITING_ADVANCE_PAYMENT: {
        color: 'var(--advanced-payment-color)',
        borderColor: 'var(--advanced-payment-border-color)',
        title: 'Awaiting advance payment',
        backgroundColor: 'var(--advanced-payment-background)',
    },
    DENTAL_TREATMENT_STARTED: {
        color: 'var(--dental-treatment-color)',
        borderColor: 'var(--dental-treatment-border-color)',
        title: 'Dental treatment started',
        backgroundColor: 'var(--dental-treatment-background)',
    },
    '1ST_STAGE_COMPLETED': {
        color: 'var(--first-stage-color)',
        borderColor: 'var(--first-stage-border-color)',
        title: '1st stage completed',
        backgroundColor: 'var(--first-stage-background)',
    },
    REPAYMENT_CONSENT_CONFIRMATION: {
        color: 'var(--consent-confirmation-color)',
        borderColor: 'var(--consent-confirmation-border-color)',
        title: 'Repayment consent confirmation',
        backgroundColor: 'var(--consent-confirmation-background)',
    },
    REPAYMENT_CONSENT_EXPIRED: {
        color: 'var(--consent-expired-color)',
        borderColor: 'var(--consent-expired-border-color)',
        title: 'Repayment consent expired',
        backgroundColor: 'var(--consent-expired-background)',
    },
    ERROR: {
        color: 'var(--error-color)',
        borderColor: 'var(--error-border-color)',
        title: 'Error',
        backgroundColor: 'var(--error-background)',
    },
    ACCOUNT_VERIFICATION: {
        color: 'var(--verification-color)',
        borderColor: 'var(--verification-border-color)',
        title: 'Account verification',
        backgroundColor: 'var(--verification-background)',
    },
    [DEFAULT_STATUS_KEY]: {
        color: '#000000',
        borderColor: '#C5C5C5',
        title: '',
        backgroundColor: '#C5C5C5',
    },
};
